import { graphQLBase } from '..'
import gql from 'graphql-tag'

const ApplicationsAPI = {
  getApplicationById: graphQLBase(
    `query getApplicationById($id: ID!) {
      getApplication(clientId: $id) {
        id
        name
        clientId
        description
        photoURL
        createdAt
        installationUrls {
          organization
        }
        isInstalled
        integration {
          id
          createdAt
          createdBy {
            displayName
          }
        }
        labels {
          shareToAction
          shareToActionVerb
          shareToSuccess
          shareToSuccessLinkLabel
          userConnectIncentive
        }
        features
  }
    }`,
    ({ getApplication }) => getApplication
  ),
  revokeIntegrationById: graphQLBase(
    `
  mutation revokeIntegrationById($integrationId: ID!) {
    revokeIntegration(integrationId: $integrationId)
  }
  `,
    ({ revokeApplication }) => revokeApplication
  ),
  shareToApplication: gql`
    mutation shareToApplication($noteId: ID!, $clientId: ID!, $target: JSON!) {
      shareToApplication(
        input: { noteId: $noteId, target: $target, clientId: $clientId }
      ) {
        url
      }
    }
  `,
  postInviteLink: gql`
    mutation postInviteLink($clientId: ID!, $target: JSON!) {
      postInviteLink(input: { clientId: $clientId, target: $target }) {
        success
      }
    }
  `,
}

export default ApplicationsAPI
